<div class='Home-banner_wrapper container pb-5'>
  <div class='d-flex flex-lg-row flex-column flex-sm-column'>
    <div class='flex-grow-1'>
      <div class='d-flex flex-column'>
        <div class='flex-grow-1 Home-banner_wrapper_video'>
          <div
            class='Home-banner_wrapper_video_wrapper ms-2 d-inline-block mt-2'>
            <div
              class='wistia_video_foam_dummy'
              data-source-container-id=''
              style='
                border: 0px;
                display: block;
                height: 0px;
                margin: 0px;
                padding: 0px;
                position: static;
                visibility: hidden;
                width: auto;
              '></div>
            <iframe
              allowfullscreen='allowfullscreen'
              allowtransparency='true'
              class='wistia_embed video-home'
              frameborder='0'
              height='267'
              mozallowfullscreen='mozallowfullscreen'
              msallowfullscreen='msallowfullscreen'
              name='wistia_embed'
              oallowfullscreen='oallowfullscreen'
              scrolling='no'
              src='//fast.wistia.net/embed/iframe/lqblzjyfo5?videoFoam=true'
              style='width: 474px; height: 267px'
              webkitallowfullscreen='webkitallowfullscreen'
              width='474'></iframe>
            <script
              async=''
              src='//fast.wistia.net/assets/external/E-v1.js'></script>
          </div>
        </div>
        <div class='flex-grow-1'>
          <div class='Home-banner_wrapper_video_announcement text-center'>
            <h2>
              <span><a class='' href='/announcements'>Announcements</a></span>
            </h2>
          </div>
        </div>
      </div>
    </div>
    <div class='flex-grow-1 Home-banner_wrapper_info'>
      <h2>Sales Soar With</h2>
      <h1>Retreva</h1>
      <ul>
        <li>Virtual Sales Assistant</li>
        <li>Intelligent Prospecting</li>
        <li>Effective Content</li>
        <li>Diligent Follow Up</li>
        <li>Eliminates Tasks</li>
      </ul>
      <a class='Home-banner_wrapper_info_learn-button' href='/about_us'
      >Learn More</a
      ><a class='Home-banner_wrapper_info_get-button' href='/register'
    >Get Started</a
    >
    </div>
  </div>
</div>
